module.exports = __webpack_public_path__ + "static/media/ui-ux-graphics.8c77eaf4.svg";